// extracted by mini-css-extract-plugin
export default {"dtmoodCardImage":"NoticiasEventosCard_dtmoodCardImage__0leZ9","cardContainer":"NoticiasEventosCard_cardContainer__yddOn","cardFooter":"NoticiasEventosCard_cardFooter__n3okV"};